import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/img_header_completa.png'
import _imports_1 from '../assets/images/img_chica.png'
import _imports_2 from '../assets/images/115.png'
import _imports_3 from '../assets/images/15.png'
import _imports_4 from '../assets/images/70.png'
import _imports_5 from '../assets/images/60.png'
import _imports_6 from '../assets/images/980.png'
import _imports_7 from '../assets/images/Ingieneria.png'
import _imports_8 from '../assets/images/Hotel.png'
import _imports_9 from '../assets/images/Economico.png'
import _imports_10 from '../assets/images/Ciencias.png'


const _hoisted_1 = {
  id: "home",
  class: "h600 d-flex align-items-center"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center text-center bg-gray" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-12 col-lg-5 pb-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "male",
    src: _imports_0,
    class: "mw-none pt-5 hide-on-small"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-6 col-md-6 col-lg-4 text-left md:pl-6 hide-on-small" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vertical-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title-text mx-4" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "study-text" }, "Estudia tu"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "master-text" }, "licenciatura"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "line-text" }, "100% en línea")
    ]),
    /*#__PURE__*/_createElementVNode("h2", { class: "pt-2 header-subtitle mx-4 md:text-white md:font-weight-normal" }, " Gradúate con validez oficial desde 2 años 2 meses ")
  ])
], -1)
const _hoisted_6 = { class: "col-sm-12 col-md-4 col-lg-3 form hide-on-small" }
const _hoisted_7 = { class: "px-0" }
const _hoisted_8 = { class: "row justify-content-center show-on-small mt-5" }
const _hoisted_9 = { class: "bg-oval" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sms-12\"><div class=\"text-center pt-5\"><h1 class=\"title-text mx-4\"><span class=\"master-text\">Estudia tu licenciatura</span><br><span class=\"master-text\">100% en línea</span></h1><h2 class=\"pt-2 header-subtitle mx-4 md:text-white md:font-weight-normal\"> Gradúate con validez oficial desde 2 años 2 meses </h2></div></div>", 1)
const _hoisted_11 = { class: "col-sm-12 pt-4 text-center card-hidden" }
const _hoisted_12 = { class: "px-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("section", {
  id: "us",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "container pt-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-lg-6 offset-lg-1 card-container px-4" }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "pb-2 font-weight-bold" }, " Somos la universidad que combina la experiencia en la educación, con avance tecnológico. "),
        /*#__PURE__*/_createElementVNode("p", { class: "pb-3 hide-on-small" }, " Nuestro modelo 100% en línea se enfoca en atender las necesidades de nuestros alumnos, fomentando autonomía y desarrollo de conocimiento en cada uno de los estudiantes, desarrollando conocimientos relevantes en el mundo laboral. "),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/#home",
          class: "button-yellow p-button-rounded font-weight-bold hide-on-small link-as-button"
        }, " Regístrate ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "hide-on-small col-sm-12 col-lg-3 offset-lg-1 card-container mt-2 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "male",
          src: _imports_1,
          height: "400",
          class: "mw-none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "show-on-small col-sm-12 col-lg-3 offset-lg-1 card-container mt-2 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "male",
          src: _imports_1,
          class: "mw-none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-lg-6 offset-lg-1 card-container px-4 show-on-small" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "pb-3" }, " Nuestro modelo 100% en línea se enfoca en atender las necesidades de nuestros alumnos, fomentando autonomía y desarrollo de conocimiento en cada uno de los estudiantes, desarrollando conocimientos relevantes en el mundo laboral. "),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/#home",
          class: "button-yellow p-button-rounded font-weight-bold hide-on-small link-as-button"
        }, " Regístrate ")
      ])
    ])
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("section", {
  id: "benefits",
  class: "d-flex align-items-center bg-gray"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row col-12 sm:pl-6 lg:offset-1 counter pb-5" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-2-5 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "+115000",
          src: _imports_2,
          class: "pt-5"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-2-5 lg:pt-6 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "+15",
          src: _imports_3,
          class: "pt-5 lg:pt-6"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-lg-2-5 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "+70",
          src: _imports_4,
          class: "pt-5"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-2-5 offset-lg-0 lg:pt-6 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "+60",
          src: _imports_5,
          class: "pt-5 lg:pt-6"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-2-5 text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "+980",
          src: _imports_6,
          class: "pt-5"
        })
      ])
    ])
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("section", {
  id: "work",
  class: "py-4 d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "container sm:mx-5 px-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row col-12 pt-4 master" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-md-12 col-lg-4 fadeIn",
        "data-wow-delay": "0.2s"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "md:col-6 lg:col-12 sm:py-3" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "px-2 mh-64" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: _imports_7,
                alt: "",
                class: "pr-3 pt-2"
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "list-title pl-5 mb-0" }, "Ingeniería")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "pl-0 master-list" }, [
              /*#__PURE__*/_createElementVNode("ul", null, [
                /*#__PURE__*/_createElementVNode("li", null, "Ingeniería en Sistemas Computacionales"),
                /*#__PURE__*/_createElementVNode("li", null, "Ingeniería Industrial"),
                /*#__PURE__*/_createElementVNode("li", null, "Ingeniería Industrial y Administración")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "md:col-6 lg:col-12 sm:py-3" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "px-2 mh-64" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: _imports_8,
                alt: "",
                class: "pr-3 pt-2"
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "list-title pl-5 mb-0" }, "Hospitalidad y Turismo")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "pl-0 master-list" }, [
              /*#__PURE__*/_createElementVNode("ul", null, [
                /*#__PURE__*/_createElementVNode("li", null, "Desarrollo Sustentable y Ecoturismo")
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-md-6 col-lg-4 fadeIn",
        "data-wow-delay": "0.2s"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "md:col-6 lg:col-12 sm:py-3" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "px-2 mh-64" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: _imports_9,
                alt: "",
                class: "pr-3 pt-2"
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "list-title pl-5 mb-0" }, "Económico Administrativas")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "pl-0 master-list" }, [
              /*#__PURE__*/_createElementVNode("ul", null, [
                /*#__PURE__*/_createElementVNode("li", null, "Administración de Negocios"),
                /*#__PURE__*/_createElementVNode("li", null, "Administración de Recursos Humanos"),
                /*#__PURE__*/_createElementVNode("li", null, "Administración de Tecnologías de la Información"),
                /*#__PURE__*/_createElementVNode("li", null, "Contaduría Pública"),
                /*#__PURE__*/_createElementVNode("li", null, "Administración"),
                /*#__PURE__*/_createElementVNode("li", null, "Administración de Ventas"),
                /*#__PURE__*/_createElementVNode("li", null, "Administración y Finanzas"),
                /*#__PURE__*/_createElementVNode("li", null, "Contaduría y Finanzas"),
                /*#__PURE__*/_createElementVNode("li", null, "Economía y Finanzas"),
                /*#__PURE__*/_createElementVNode("li", null, "Mercadotecnia"),
                /*#__PURE__*/_createElementVNode("li", null, "Negocios internacionales")
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-md-12 col-lg-4 fadeIn",
        "data-wow-delay": "0.2s"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "md:col-6 lg:col-12 sm:py-3" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "px-2 mh-64" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: _imports_10,
                alt: "",
                class: "pr-3 pt-2"
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "list-title pl-5 mb-0" }, "Ciencias Sociales y Humanidades")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "pl-0 master-list" }, [
              /*#__PURE__*/_createElementVNode("ul", null, [
                /*#__PURE__*/_createElementVNode("li", null, "Criminología y Criminalistica"),
                /*#__PURE__*/_createElementVNode("li", null, "Ciencias Políticas y Administración Pública"),
                /*#__PURE__*/_createElementVNode("li", null, "Derecho"),
                /*#__PURE__*/_createElementVNode("li", null, "Derecho Empresarial"),
                /*#__PURE__*/_createElementVNode("li", null, "Derecho Internacional"),
                /*#__PURE__*/_createElementVNode("li", null, "Pedagogía "),
                /*#__PURE__*/_createElementVNode("li", null, "Psicología"),
                /*#__PURE__*/_createElementVNode("li", null, "Psicología Organizacional"),
                /*#__PURE__*/_createElementVNode("li", null, "Tecnología Educativa")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeText = _resolveComponent("TypeText")!
  const _component_TypeEmail = _resolveComponent("TypeEmail")!
  const _component_TypePhone = _resolveComponent("TypePhone")!
  const _component_TypeDropDown = _resolveComponent("TypeDropDown")!
  const _component_TypeRadioButton = _resolveComponent("TypeRadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _createElementVNode("form", _hoisted_7, [
                  _createVNode(_component_TypeText, {
                    class: "",
                    "answer-key": "name",
                    "validation-label": "Este campo es obligatorio",
                    isRequired: true,
                    isSubmitted: _ctx.submitted,
                    placeholder: "Nombre(s)",
                    onGetValue: _ctx.setValue
                  }, null, 8, ["isSubmitted", "onGetValue"]),
                  _createVNode(_component_TypeText, {
                    class: "",
                    "answer-key": "paternalSurname",
                    "validation-label": "Este campo es obligatorio",
                    isRequired: true,
                    isSubmitted: _ctx.submitted,
                    placeholder: "Apellidos",
                    onGetValue: _ctx.setValue
                  }, null, 8, ["isSubmitted", "onGetValue"]),
                  _createVNode(_component_TypeEmail, {
                    class: "",
                    "answer-key": "email",
                    "validation-label": "Este campo es obligatorio",
                    isRequired: true,
                    isSubmitted: _ctx.submitted,
                    onGetValue: _ctx.setValue
                  }, null, 8, ["isSubmitted", "onGetValue"]),
                  _createVNode(_component_TypePhone, {
                    "answer-key": "phone",
                    "validation-label": "Este campo es obligatorio",
                    isRequired: true,
                    isSubmitted: _ctx.submitted,
                    placeholder: "Teléfono móvil",
                    onGetValue: _ctx.setValue
                  }, null, 8, ["isSubmitted", "onGetValue"]),
                  _createVNode(_component_TypeDropDown, {
                    "answer-key": "interest",
                    isRequired: true,
                    isSubmitted: _ctx.submitted,
                    "validation-label": "Este campo es obligatorio",
                    catalog: _ctx.programs,
                    onGetValue: _ctx.setValue
                  }, null, 8, ["isSubmitted", "catalog", "onGetValue"]),
                  _createVNode(_component_TypeRadioButton, {
                    class: "",
                    "answer-key": "terms-privacy",
                    "validation-label": "Este campo es obligatorio",
                    isRequired: true,
                    isSubmitted: _ctx.submitted,
                    onGetValue: _ctx.setValue
                  }, null, 8, ["isSubmitted", "onGetValue"])
                ])
              ]),
              content: _withCtx(() => [
                _createVNode(_component_Button, {
                  onClick: _ctx.register,
                  label: "Regístrate",
                  loading: _ctx.loading,
                  class: "button-yellow p-button-rounded font-weight-bold"
                }, null, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Card, null, {
                title: _withCtx(() => [
                  _createElementVNode("form", _hoisted_12, [
                    _createVNode(_component_TypeText, {
                      class: "",
                      "answer-key": "name",
                      "validation-label": "Este campo es obligatorio",
                      isRequired: true,
                      isSubmitted: _ctx.submitted,
                      placeholder: "Nombre(s)",
                      onGetValue: _ctx.setValue
                    }, null, 8, ["isSubmitted", "onGetValue"]),
                    _createVNode(_component_TypeText, {
                      class: "",
                      "answer-key": "paternalSurname",
                      "validation-label": "Este campo es obligatorio",
                      isRequired: true,
                      isSubmitted: _ctx.submitted,
                      placeholder: "Apellidos",
                      onGetValue: _ctx.setValue
                    }, null, 8, ["isSubmitted", "onGetValue"]),
                    _createVNode(_component_TypeEmail, {
                      class: "",
                      "answer-key": "email",
                      "validation-label": "Este campo es obligatorio",
                      isRequired: true,
                      isSubmitted: _ctx.submitted,
                      onGetValue: _ctx.setValue
                    }, null, 8, ["isSubmitted", "onGetValue"]),
                    _createVNode(_component_TypePhone, {
                      "answer-key": "phone",
                      "validation-label": "Este campo es obligatorio",
                      isRequired: true,
                      isSubmitted: _ctx.submitted,
                      placeholder: "Teléfono móvil",
                      onGetValue: _ctx.setValue
                    }, null, 8, ["isSubmitted", "onGetValue"]),
                    _createVNode(_component_TypeDropDown, {
                      "answer-key": "interest",
                      isRequired: true,
                      isSubmitted: _ctx.submitted,
                      "validation-label": "Este campo es obligatorio",
                      catalog: _ctx.programs,
                      onGetValue: _ctx.setValue
                    }, null, 8, ["isSubmitted", "catalog", "onGetValue"]),
                    _createVNode(_component_TypeRadioButton, {
                      class: "",
                      "answer-key": "terms-privacy",
                      "validation-label": "Este campo es obligatorio",
                      isRequired: true,
                      isSubmitted: _ctx.submitted,
                      onGetValue: _ctx.setValue
                    }, null, 8, ["isSubmitted", "onGetValue"])
                  ])
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_Button, {
                    onClick: _ctx.register,
                    label: "Regístrate",
                    loading: _ctx.loading,
                    class: "button-yellow p-button-rounded font-weight-bold"
                  }, null, 8, ["onClick", "loading"])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_13,
    _hoisted_14,
    _hoisted_15
  ]))
}